import { useState } from "react";
import { StriimTheme, StriimMessageBox, StriimIconButton } from "@striim/striim-ui-v2";
import { Close } from "../../../../../src/generic/icon/customIcons";
import { Box } from "@mui/material";

const styles = {
    container: {
        padding: "8px 16px"
    },
    customCard: {
        backgroundColor: "#D9E5F0",
        display: "flex",
        alignItems: "baseline"
    },
    iconStyles: {
        marginRight: "8px"
    }
};

const FlowMessageBox = () => {
    const initialHide = localStorage.getItem("hideFDMessageBox");
    const [hideMessageBox, setHideMessageBox] = useState(initialHide);

    const handleClose = () => {
        setHideMessageBox(true);
        localStorage.setItem("hideFDMessageBox", true);
    };

    if (hideMessageBox) return null;
    return (
        <StriimTheme>
            <Box sx={styles.container}>
                <StriimMessageBox
                    text={
                        "You can only write to the same target type at any time across all your running apps. If you want to write to a different target type in this app, then you must stop and undeploy any other apps that are running before you can run this app"
                    }
                    type="NOTIFICATION"
                    customCardStyles={styles.customCard}
                    actions={
                        <StriimIconButton sx={styles.iconStyles} onClick={() => handleClose()}>
                            <Close fontSize={18} />
                        </StriimIconButton>
                    }
                />
            </Box>
        </StriimTheme>
    );
};

export default FlowMessageBox;
